import { NAME } from './constants';

export const ADD_CAMPAIGN_STATE = `${NAME}/ADD_CAMPAIGN_STATE`;
export const ENABLE_SAVE = `${NAME}/ENABLE_SAVE`;
export const REMOVE_CAMPAIGN_STATE = `${NAME}/REMOVE_CAMPAIGN_STATE`;
export const SET_CAMPAIGN_STATE = `${NAME}/SET_CAMPAIGN_STATE`;
export const UPDATE_CAMPAIGN_STATES = `${NAME}/UPDATE_CAMPAIGN_STATES`;
